import React from 'react'
import { useTranslation } from 'react-i18next'

import Checkboxes from 'js/components/Checkbox/Checkboxes'
import Cloud from 'js/components/Cloud/Cloud'
import FilterWrapper from 'js/components/FilterWrapper'
import { H5 } from 'js/components/Heading'
import Select from 'js/components/Select/Select'
import setTagFilterHelper from 'js/page/Widget/components/Feed/setTagFilter'

const TagCategoriesFilter = ({
    name,
    tagCategories,
    tagFilter,
    setTagFilter,
    searchTagFilters,
}) => {
    const { t } = useTranslation()

    // Get filter settings for each tag category
    const tagCategoryFilters =
        searchTagFilters?.reduce(
            (acc, tagCategory) => ({
                ...acc,
                [tagCategory.name]: tagCategory,
            }),
            {},
        ) || {}

    // Filter tag categories that are enabled as filter and merge tagFilterType into the tagCategory
    const mergedTagCategories = tagCategories
        .filter(
            (category) => tagCategoryFilters[category.name]?.tagFilterEnabled,
        )
        .map((category) => ({
            ...category,
            tagFilterType: tagCategoryFilters[category.name]?.tagFilterType,
        }))

    return (
        <FilterWrapper>
            {mergedTagCategories.map((category, index) => {
                const options = category.values.map((tag) => ({
                    value: tag,
                    label: tag,
                }))

                const categoryName = category.name
                const value =
                    tagFilter.find((cat) => cat.name === categoryName)
                        ?.values || []

                const handleChange = (val) => {
                    setTagFilterHelper(setTagFilter, categoryName, val)
                }

                const id = `${name}-tag-category-${index}`

                const tagFilterType = category.tagFilterType

                return (
                    <div key={categoryName}>
                        <H5 as="h3" style={{ marginBottom: 8 }}>
                            {categoryName}
                        </H5>

                        {tagFilterType === 'cloud' ? (
                            <Cloud
                                key={id}
                                tagCategory={category}
                                value={value}
                                onChange={handleChange}
                            />
                        ) : tagFilterType === 'checkbox' ? (
                            <Checkboxes
                                key={id}
                                options={options}
                                value={value}
                                onChange={handleChange}
                                fieldId={id}
                                size="small"
                            />
                        ) : (
                            <Select
                                key={id}
                                name={id}
                                placeholder={t('filters.filter-by')}
                                options={options}
                                value={value}
                                onChange={handleChange}
                                isMulti
                            />
                        )}
                    </div>
                )
            })}
        </FilterWrapper>
    )
}

export default TagCategoriesFilter
